if (!customElements.get('review-banner')) {
  customElements.define('review-banner',
    class ReviewBanner extends HTMLElement {
      connectedCallback() {
        this.cta = this.querySelector('.review-banner__cta');
        if (!this.cta) return;
        this._onCtaClick = this.handleCtaClick.bind(this);
        this.cta.addEventListener('click', this._onCtaClick);
      }

      disconnectedCallback() {
        if (this.cta && this._onCtaClick) {
          this.cta.removeEventListener('click', this._onCtaClick);
        }
        this.cta = null;
        this._onCtaClick = null;
      }

      handleCtaClick(event) {
        const href = this.cta.getAttribute('href');
      
        if (href && href.startsWith('#') && href.length > 1) {
          const target = document.querySelector(href);
      
          if (target) {
            event.preventDefault();
      
            const isDesktop = window.innerWidth >= 1024;
      
            let offset = 0;
            if (isDesktop) {
              const header = document.querySelector('.section-header');
              offset = header ? header.offsetHeight : 0;
            }
      
            const targetPosition =
              target.getBoundingClientRect().top +
              window.pageYOffset -
              offset;
      
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  );
}
